import { ReactNode } from 'react'
import { ILabelStyleType, Label } from '@/components/label'
import { IChildrenProps } from '@/typings/children-props'
import { cn } from '@/utils/styles/cn'

interface ILabeledContainerProps extends IChildrenProps {
    className?: string
    labelStyleType?: ILabelStyleType
    label: ReactNode
}

export const LabeledContainer = ({
    children,
    className,
    labelStyleType,
    label,
}: ILabeledContainerProps) => {
    return (
        <div className={cn('flex flex-col space-y-2', className)}>
            <Label label={label} styleType={labelStyleType} />

            {children}
        </div>
    )
}
